var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_24_actions_timer",
    "data-name": "ico / 24 / actions / timer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M8.993,20c-.081,0-.163,0-.244,0A9.111,9.111,0,0,1,0,11,9,9,0,0,1,7.007,2.23V1a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V2.23A9.053,9.053,0,0,1,14.615,4l1.112-1.17a.5.5,0,0,1,.711,0l.71.71a.5.5,0,0,1,0,.7l-1.13,1.13A9,9,0,0,1,8.993,20ZM9.01,4a7,7,0,1,0,7.007,7A7.012,7.012,0,0,0,9.01,4Zm.38,8h-.76a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h.76a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,9.39,12Z",
    transform: "translate(3 2)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.ed695fb51d7af443f05a6d6fa780d1ff.svg";
export { ForwardRef as ReactComponent };